import React from "react";

const UnapprovedProduce = () => {

    return (
        <div className="buyer-dashboard">
            <div className="text">Welcome to Amtpl Unapproved Produce page</div>


        </div>
    );
};

export default UnapprovedProduce